// src/jsx/app.jsx
import {
	useNavigate,
	useLocation
  } from 'react-router-dom';
import React, { useEffect,useState } from 'react';

import Footer from './views/components/payg/commonModules/footer.jsx';
import MainContentAdminPAYG from './views/components/payg/adminModule/maincontentadminpayg.jsx';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {getAccess} from './jsx/actions/accessAction'
import { TranslateProvider } from 'translate-components'
import translations from './translations.json'
import 'moment/locale/fr'
import Header from './views/components/payg/commonModules/layouts/Header.jsx';
import { Box } from '@material-ui/core';
import {messaging} from './firebase';
import setAuthToken from './jsx/utils/setAuthToken.js';
import { setCurrentUser } from './jsx/actions/authAction.jsx';
import { isEmpty } from 'lodash-es';

//import { withRouter } from "react-router";

// Initialised model with meta data
var element = document.querySelector('meta[name-user="username"]');
var content = element && element.getAttribute("content");
var UserName = content;

var elementToken = document.querySelector('meta[token-user="tokenUser"]');
var contentToken = elementToken && elementToken.getAttribute("content");
var TokenUser = contentToken;


function MainViewI(props) {
	const navigate = useNavigate();
	const location = useLocation();

	const [inLeftSideBar, setinLeftSideBar] = useState("none");
	const [mainContent, setmainContent] = useState("Accueil");
	const [mainContentProps, setmainContentProps] = useState(null);
	const [isInit, setIsInit] = useState(false);

	useEffect(() => {
		if (!isInit){
			try{
				Notification.requestPermission();
				messaging.getToken({vapidKey: 'BBjo5I9JqKdsmvue-ND-GKB-9c13MD_6BWMiOioGh2QjuAL2M1ilQDyRTZlIp3qxZ7gj7d3kA9k-kW3vETjju1U'}).then((currentToken) => {
					if (currentToken) {
					  console.log('current token for client: ', currentToken);
					  // Track the token -> client mapping, by sending to backend server
					  // show on the UI that permission is secured
					  sendTokenServer(currentToken)
					} else {
					  console.log('No registration token available. Request permission to generate one.');
					  // shows on the UI that permission is required 
					}
				  }).catch((err) => {
					console.log('An error occurred while retrieving token. ', err);
					// catch error while creating client token
				  });
		
				}catch{
					
				}
				console.log('[DEBUG], MainView, indexAdmin,componentDidMount ',props);	
				if (isEmpty(props.page)){
					props.getAccess(props.pageRaw)	
				}				
				setIsInit(true)
		}
		
	  });
	
	const sendTokenServer = async (currentToken) =>{
		const response = await fetch('/notification/fccm/key',{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				//'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
			},
			body: JSON.stringify({
				expoPushToken: currentToken,
			}),
			credentials: 'same-origin',
		})
		const resp2 = await response.json()
		console.log({resp2});
	}
	

	const handleUserInput = ( inLeftSideBar) => {
		if (inLeftSideBar === 'UserProfile'){
			setinLeftSideBar("none")
			setmainContent(inLeftSideBar)
		} else {
			setmainContent(inLeftSideBar)
		}
	}
	const  handleSelectMenu = (selectedMenu, propslocal = null) => {
		console.log("MAJOR MENU -----", selectedMenu, " page ",props.page);
		if(!props.page.includes(selectedMenu) && selectedMenu !== "Accueil"){
			selectedMenu = "Accueil"
		}
		setinLeftSideBar("none")
		setmainContent(selectedMenu)
		setmainContentProps(propslocal)

		console.log("ORIGIN >> +",selectedMenu)
		switch (selectedMenu) {
			case "Accueil":
				navigate('home')
				break;
			case "Dashboard":	
				navigate('dashboard')
				break;	
			case "Dépenses":
				navigate('spendings')
				break;
			case "Extract":
				navigate('extracts')
				break;
			case "Home":
				navigate('userlist')
				break;
			case "Entrer Paiement":
				navigate('payment')
				break;	
			case "Paiement":
				navigate('paymentlist')
				break;
			case "Configuration":
				navigate('configuration')
				break;
			case "Paramètres":
				navigate('configuration')
				break;
			case "Commercial":
				navigate('commercial')
				break;
			case "Devis":
				navigate('quote')
				break;
			case "Magasin":
				navigate('store')
				break;
			case "Maintenance":
				navigate('maintenance')
				break;
			case "Recouvrement":
				navigate('recovery')
				break;
			case "Production":
				navigate('production')
				break;
			case "Consommation":
				navigate('consumption')
				break;	
			case "Mini-grid":
				navigate('minigrid')
				break;	
			default:
				break;
		}
	}
	const RemoveMenus = () => {
		setinLeftSideBar("none")
	}

	return(
			<>
				<TranslateProvider debugMode={true} translations={translations} defaultLanguage={props.language}>
				<Box>
					<Header
						barStatus={inLeftSideBar}
						handleUserProfile={handleUserInput}
						userName = " bring energy anywhere"
						ClickOnMenu={handleSelectMenu}
						SelectedMenu={mainContent}
						{...props}
					/>
						<section id="main" className={ mainContent === "Dashboard" && "bgm-dashboard"}>
						 <MainContentAdminPAYG
								mainContent= {mainContent}
								tokenUser = {TokenUser}
								ClickOnMenu={handleSelectMenu}
								mainContentProps={mainContentProps}
								RemoveMenus={RemoveMenus}
							/> 
						</section>
					<Footer/>
				</Box>
				</TranslateProvider>
			</>
		)
}

const mapStateToProps = (state) => {
return {
	language: state.language,
	page : state.userAccess.PAGES,
	pageRaw : state.auth.pageRaw,
	// pageRaw : state.auth.user.tokenAcess,
	token : state.auth.token,
	auth : state.auth,
}
}
function mapDispatchToProps(dispatch){
return bindActionCreators({
	
	getAccess: getAccess,
}, dispatch)
}


const App = connect(mapStateToProps, mapDispatchToProps)(MainViewI)

export default App;

